module.exports = __webpack_public_path__ + "img/default-photo.160398f0.jpg";